import { useMemo } from 'react'
import Button from '@dd3tech/wiggui/Button'
import Modal from '@dd3tech/wiggui/Modal'
import Text from '@dd3tech/wiggui/Text'
import OptionButton from '@dd3tech/wiggui/OptionButton'
import Flex from '@dd3tech/wiggui/Flex'
import { Avatar } from '@dd3tech/wiggui/Avatar'
import { MdCheck, MdSupportAgent } from 'react-icons/md'
import { composeClasses, createUrlMedia } from '@wiggot/utils'
import { usePending } from './usePending'
import { useAuth, useWhatsapp } from '../../../../../../hooks'
import { useModalBrokerInvitationStore } from '../../../../../../store/modals-services/modal-broker-invitation'
import { WHATSAPP_WIGGOT_CUSTOMER_SUPPORT } from '../../../../../../constants'

export const Pending = () => {
  const invitationData = useModalBrokerInvitationStore(
    (state) => state.invitationData
  )
  const { isLoadingLogout, handleLogout } = useAuth()
  const { isLoading, setStep, step, handleDeclined, isError, isSuccess } =
    usePending()
  const { redirectToWhatsapp } = useWhatsapp()

  const handleTextButton = useMemo(() => {
    if (isSuccess) {
      return 'Solicitud cancelada'
    }

    if (step === 1) {
      return 'Cancelar solicitud'
    }

    return 'Sí, cancelar solicitud'
  }, [step, isSuccess])

  const handleHelpClick = () => {
    redirectToWhatsapp({
      openInNewTab: true,
      phone: WHATSAPP_WIGGOT_CUSTOMER_SUPPORT,
      text: 'Hola. Necesito ayuda para formar parte de una agencia.'
    })
  }

  const logoUrl = invitationData?.logo
    ? createUrlMedia({
        id: invitationData?.logo
      })
    : undefined

  return (
    <>
      <Modal.Body>
        <Flex dir="col" items="center" justify="start" gap="gap-6" wFull>
          <Flex dir="row" items="center" justify="between" gap="gap-3" wFull>
            <Avatar
              containerClassName="rounded-full min-w-[40px] min-h-[40px] w-10 h-10"
              avatarUrl={logoUrl}
              fullName={invitationData?.agencyName}
            />
            <OptionButton
              onClick={handleHelpClick}
              variant="gray"
              rightIcon={
                <MdSupportAgent className="text-secondary min-w-[20px] min-h-[20px]" />
              }
            >
              <span className="underline text-secondary">Ayuda</span>
            </OptionButton>
          </Flex>
          <Flex dir="col" items="center" justify="start" gap="gap-6" wFull>
            <Text className="text-headline-s text-primary font-semibold text-left w-full">
              {step === 1
                ? `Solicitaste formar parte de la agencia ${
                    invitationData?.agencyName || ''
                  }`
                : '¿Quieres cancelar tu solicitud?'}
            </Text>
            <Text className="text-secondary text-body-m text-left w-full">
              {step === 1
                ? `Al formar parte de la agencia todas tus propiedades y contactos
              formarán parte de la inmobiliaria y tendrás acceso a las
              propiedades de la misma.`
                : `Si cancelas tu solicitud no tendrás acceso a  ${
                    invitationData?.agencyName || ''
                  }.`}
            </Text>
            <Text className="text-secondary text-body-bold-m text-left w-full">
              {step === 1
                ? 'Recibirás un correo con la respuesta en breve.'
                : 'Continúa como agente independiente y disfruta de tu prueba gratuita para conocer las herramientas de Wiggot.'}
            </Text>
          </Flex>
        </Flex>
      </Modal.Body>
      <Modal.Footer className="flex-col flex py-3 border-t gap-3 border-surface-strokes items-center w-full px-6 justify-between">
        <Flex dir="row" items="center" justify="between" gap="gap-3" wFull>
          {!isSuccess && (
            <Button
              isDisabled={isLoading}
              isLoading={isLoadingLogout}
              variant="link"
              className="!px-0"
              onClick={(event) => {
                event.stopPropagation()
                if (step === 1) {
                  handleLogout()
                  return
                }
                setStep(1)
              }}
            >
              {step === 1 ? 'Cerrar sesión' : 'Regresar'}
            </Button>
          )}
          <Button
            isDisabled={isLoadingLogout}
            isLoading={isLoading}
            className={composeClasses(
              isSuccess &&
                '!transition-colors !duration-500 !bg-notif-green !text-primary pointer-events-none'
            )}
            fullWidth={isSuccess}
            rightIcon={isSuccess && <MdCheck className="text-[24px]" />}
            variant={step === 1 ? 'secondary' : 'cancel'}
            onClick={(event) => {
              event.stopPropagation()
              if (step === 1) {
                setStep(2)
                return
              }
              handleDeclined()
            }}
          >
            {handleTextButton}
          </Button>
        </Flex>
        {isError && (
          <p className="text-body-bold-s text-notif-red w-full text-center">
            {isError || 'Ocurrio un error al rechazar la invitación'}
          </p>
        )}
      </Modal.Footer>
    </>
  )
}
